import axios from 'axios';
import { useIdentityStore } from '@/store/IdentityStore';
// import app from '../main.js';

const API_URL = process.env.VUE_APP_API_URL;
const apiClient = axios.create({
	baseURL: API_URL,
	withCredentials: false,
});
apiClient.interceptors.request.use(config => {
 // app.config.globalProperties.$Progress.start();
  var token = useIdentityStore().access_token();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  response => {
   // app.config.globalProperties.$Progress.finish();
    return response;
  },
  error => {
    if (error.response && error.response.status === 403) {
      console.error('Access denied. Redirecting to login.');
      var identityStore = useIdentityStore();
      var refreshToken = identityStore.refresh_token();
      if (refreshToken) {
        identityStore.ssoRefreshToken(refreshToken).then(() => {
          var token = identityStore.access_token();
          if (!token) {
            identityStore.ssoAuthenticate();
          }
        });
      }
    }
    console.error('ERROR: ' + error);
    return Promise.reject(error);
  },
);
export default {
	async getSprinklers () {
		return await apiClient.get('/api/orchard/sprinklers', {
			headers: {
				Accept: 'text/plain',
				'Authorization': 'Bearer ' + this.token,
				'Content-Type': 'application/json; charset=utf-8',
			},
		});
	},
	async getModels (id) {
		return await apiClient.get('/api/orchard/models/' + id, {
			headers: {
				Accept: 'text/plain',
				'Authorization': 'Bearer ' + this.token,
				'Content-Type': 'application/json; charset=utf-8',
			},
		});
	},
	async getPlates (id) {
		return await apiClient.get('/api/orchard/plates/' + id, {
			headers: {
				Accept: 'text/plain',
				'Authorization': 'Bearer ' + this.token,
				'Content-Type': 'application/json; charset=utf-8'
			}
		});
	},
	async getNozzles (id) {
		return await apiClient.get('/api/orchard/nozzles/' + id, {
			headers: {
				Accept: 'text/plain',
				Authorization: 'Bearer ' + this.token,
				'Content-Type': 'application/json; charset=utf-8',
			},
		});
	},
	async getPipes () {
		return await apiClient.get('/api/orchard/pipes?select=Both', {
			headers: {
				Accept: 'application/json',
				Authorization: 'Bearer ' + this.token,
				'Content-Type': 'application/json; charset=utf-8',
			},
		});
	},
	async postPipe (pipe) {
		return await apiClient.post('/api/orchard/pipes', pipe,
			{
				headers: {
					Accept: 'application/json',
					Authorization: 'Bearer ' + this.token,
					'Content-Type': 'application/json; charset=utf-8',
				}
			}
		);
	},
	async removePipe (pipeId) {
		return await apiClient.delete('/api/orchard/pipes/' + pipeId, {
			headers: {
				Accept: 'application/json',
				Authorization: 'Bearer ' + this.token,
				'Content-Type': 'application/json; charset=utf-8',
			}
		});
	},
	async sprinklerCalc (payload) {
		return await apiClient.post('/api/orchard/calc', payload, {
			headers: {
				Accept: 'application/json',
				Authorization: 'Bearer ' + this.token,
				'Content-Type': 'application/json; charset=utf-8',
			}
		});
	},
	async logError (error, info) {
		const logArray = {
			'error': error.stack,
			'info': info
		};
		return await apiClient.post('/log/', JSON.stringify(logArray), {
			headers: {
				Accept: 'application/json',
				'Authorization': 'Bearer ' + this.token,
				'Content-Type': 'application/json; charset=utf-8'
			}
		});
	},
	data () {
		return {
			token: null
		};
	},
	setAuthHeader (_token) {
		this.token = _token;
	},
};